import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-play-mini-fill text-white text-xl md:text-2xl"></i>
            </div>
            <span className={`font-heading text-xl md:text-2xl font-bold transition-colors duration-300 ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}>
              茄子视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                  location.pathname === link.href
                    ? scrolled
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-white/20 text-white'
                    : scrolled
                      ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                      : 'text-white/85 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className={`w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
              scrolled
                ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                : 'text-white/80 hover:text-white hover:bg-white/10'
            }`} aria-label="搜索">
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/category"
              className={`px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer transition-all ${
                scrolled
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white text-primary-600 hover:bg-white/90'
              }`}
            >
              开始观看
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${
              scrolled ? 'text-foreground-700' : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                  location.pathname === link.href
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category"
              className="mt-2 px-4 py-3 rounded-full text-sm font-semibold text-center bg-primary-500 text-white hover:bg-primary-600 cursor-pointer whitespace-nowrap transition-colors"
            >
              开始观看
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}